import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames/bind';
import * as graph from '@adc/sdk';
import styles from './index.scss';
import { InfoPill } from '../../../../elementals';
import Text from '../../../../elementals/text';
const cx = classnames.bind(styles);
const formatPaymentType = (type) => {
    const paymentTypeMap = {
        CASH: 'Cash',
        CONVENTIONAL: 'Conventional Financing',
        FHA: 'FHA Financing',
        VA: 'VA Financing',
        USDA: 'USDA Financing',
        REHAB_LOAN: 'Rehab Loan',
        LINE_OF_CREDIT: 'Line of Credit',
        HARD_MONEY_LOAN: 'Hard Money Loan',
        OTHER: 'Other',
    };
    return paymentTypeMap[type] || 'Other';
};
const BidRankTerms = ({ bidRank, viewingFrom = graph.enums.CurrentTargetAudience.Seller, requestRentBack, }) => {
    const terms = bidRank?.bid?.terms;
    const conditions = [
        {
            key: 'payment-type',
            content: formatPaymentType(terms?.payment_type || ''),
            enabled: viewingFrom !== graph.enums.CurrentTargetAudience.Buyer,
        },
        {
            key: 'rent-back',
            content: terms?.leaseback_duration != null && terms.leaseback_duration > 0
                ? `${terms.leaseback_duration} days of Rent Back`
                : requestRentBack
                    ? 'No Rent Back'
                    : null,
            enabled: viewingFrom !== graph.enums.CurrentTargetAudience.Buyer,
        },
        {
            key: 'emd',
            content: terms?.earnest_money_deposit_amount
                ? `EMD of $${terms.earnest_money_deposit_amount.toLocaleString()}`
                : null,
            enabled: viewingFrom !== graph.enums.CurrentTargetAudience.Buyer,
        },
        {
            key: 'closing',
            content: terms?.close_escrow_duration
                ? `${terms.close_escrow_duration} Days to Close`
                : null,
            enabled: true,
        },
        {
            key: 'option-period',
            content: terms?.inspection_contingency_period_duration != null
                ? `Option Period of ${terms.inspection_contingency_period_duration} days`
                : null,
            enabled: viewingFrom !== graph.enums.CurrentTargetAudience.Buyer,
        },
    ];
    return (_jsx("div", { className: cx('conditions-container'), children: conditions
            .filter(condition => condition.content != null && condition.enabled)
            .map((condition, index) => (_jsx(InfoPill, { "data-elm-id": `${bidRank.bid_id}-${condition.key}`, content: _jsxs(Text, { size: 'tiny', children: [condition.content, " "] }), size: 'medium', fontWeight: 'normal' }, `${bidRank.bid_id}-${condition.key}-${index}`))) }));
};
export default BidRankTerms;
//# sourceMappingURL=index.js.map